<div class="p-4 d-print-none">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card class="p-4">
        <mat-spinner class="mx-auto my-5" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center">
                    <h1 class="fs-3 fw-light mb-0"><strong>{{ dio.numero }}</strong> - {{ dio.servico.titulo }}</h1>
                </div>
                <div>
                    <button mat-icon-button color="primary" class="btn-sm" [matMenuTriggerFor]="beforeMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #beforeMenu="matMenu" xPosition="before" class="d-print-none">
                        <button mat-menu-item (click)="openAssociarCondutorDialog()" *ngIf="!dio.condutor">Associar Condutor</button>
                        <button mat-menu-item (click)="print()">Imprimir</button>
                        <button mat-menu-item (click)="openToSignDialog()" *ngIf="allowedSignatureDio()">
                            {{ dio.statusExecucao === 'AGUARDANDO_FUNCIONARIO' ? 'Atestar' : 'Validar' }}
                        </button>
                        <button mat-menu-item [routerLink]="['/dio', dio.id, 'editar']" *ngIf="allowedEditDio()">Editar</button>
                        <button mat-menu-item [routerLink]="['/dio', dio.id, 'incluir-sei']" *ngIf="allowedAddSEI()">Incluir SEI</button>
                        <button mat-menu-item (click)="showCancelarDialog()" *ngIf="allowedToCancelDio()">Cancelar</button>
                    </mat-menu>
                </div>
            </div>
            
            <!-- CRIAÇÃO -->
            <div class="callout border-primary pt-2 mb-4">
                <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">PREFIXO</span>
                        <div class="d-flex" *ngIf="dio.alocacao">
                            <span class="status-badge bg-info fs-7 lh-lg">{{ dio.alocacao.codigo }}</span>
                        </div>
                        <div class="lh-sm" *ngIf="!dio.alocacao">---</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">PLACA EQUIPAMENTO</span>
                        <div class="lh-sm">{{ dio.alocacao && dio.alocacao.equipamento ? dio.alocacao.equipamento.placa : '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">ANO DO EQUIPAMENTO</span>
                        <div class="lh-sm">{{ dio.alocacao && dio.alocacao.equipamento && dio.alocacao.equipamento.fabricacaoAno ? (dio.alocacao.equipamento.fabricacaoAno | date:'yyyy') : '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">EQUIPAMENTO</span>
                        <ng-container *ngIf=" dio.alocacao && dio.alocacao.equipamento">
                            <div class="lh-sm">{{ dio.alocacao.equipamento.modelo ? dio.alocacao.equipamento.modelo : '---' }}</div>
                            <div class="lh-sm fs-7 text-gray">{{ dio.alocacao.equipamento.marca ? dio.alocacao.equipamento.marca : '---' }}</div>
                        </ng-container>
                    </div>                    
                    <div class="col-12 mb-3">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">BENEFICIÁRIA</span>
                        <div class="lh-sm">{{ dio.contrato.beneficiaria.nome }}</div>
                        <div class="lh-sm fs-7 text-gray">{{ dio.contrato.beneficiaria.cnpj | mask:'CPF_CNPJ' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">CONTRATO</span>
                        <div class="lh-sm">{{ dio.contrato.nome }}</div>
                        <div class="lh-sm fs-7 text-gray" *ngIf="dio.contrato.beneficiaria">{{ dio.contrato.beneficiaria.nome }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">CONDUTOR</span>
                        <div class="lh-sm">{{ dio.condutor ? dio.condutor.firstName : '---' }} {{ dio.condutor ? dio.condutor.lastName : '' }}</div>
                        <div class="lh-sm fs-7 text-gray">{{ dio.condutor ? dio.condutor.email : '---' }}</div>
                    </div>
                    <div class="col-12 mb-3">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">DEMANDANTE</span>
                        <div class="lh-sm">{{ dio.demandante ? dio.demandante.nome : '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">SEI</span>
                        <div class="lh-sm">{{ dio.sei || '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">PROCESSO SEI</span>
                        <div class="lh-sm">{{ dio.precessoSei || '---' }}</div>
                    </div>
                    <div class="col-12 mb-3">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">ORGÃO</span>
                        <div class="lh-sm">{{ dio.orgao ? dio.orgao.nome : '---' }}</div>
                        <div class="lh-sm fs-7 text-gray" *ngIf="dio.localApresentacao">{{ dio.localApresentacao.nome }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">REGIÃO</span>
                        <div class="lh-sm">{{ dio.regiaoAdm ? dio.regiaoAdm.nome : '---' }}</div>
                    </div>                    
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">EXECUTOR LOCAL</span>
                        <div class="lh-sm">{{ dio.funcionarioResponsavelOrgao || '---' }}</div>
                    </div>
                    <div class="col-12 mb-3">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="col-12 col-md-4 mb-3 mb-md-0">
                        <span class="fw-bold fs-7 opacity-50">CRIADO POR</span>
                        <div class="lh-sm">{{ dio.criadorNome || '---' }}</div>
                        <div class="lh-sm fs-7 text-gray" *ngIf="dio.criadorEmail">{{ dio.criadorEmail }}</div>
                    </div>
                    <div class="col-12 col-md-4">
                        <span class="fw-bold fs-7 opacity-50">CRIADO EM</span>
                        <div class="lh-sm">{{ dio.created_at | date:'dd/MM/yyyy' }}</div>
                        <div class="lh-sm fs-7 text-gray">{{ dio.created_at | date:'HH:mm:ss' }}</div>
                    </div>
                </div>
            </div>

            <!-- EXECUÇÃO -->
            <div class="callout border-success pt-2 pb-0 mb-4">
                <h2 class="fs-6">RESUMO DA EXECUÇÃO</h2>
                <div class="col-12 mb-3">
                    <mat-divider></mat-divider>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">INICIO</span>
                        <div class="lh-sm">{{ dio.dataInicioExecucao ? (dio.dataInicioExecucao | date:'dd/MM/yyyy HH:mm:ss') : '---' }}
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">FIM</span>
                        <div class="lh-sm">{{ dio.dataFimExecucao ? (dio.dataFimExecucao | date:'dd/MM/yyyy HH:mm:ss') : '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">TOTAL HORA DISPONÍVEL</span>
                        <div class="lh-sm">{{ dio.totalHoraDisponivel || '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">STATUS</span>
                        <div class="d-flex">
                            <span class="status-badge {{getBadgeColor(dio.statusExecucao)}}">{{ dio.statusExecucao | translate }}</span>                            
                        </div>                        
                        <div class="lh-sm" *ngFor="let cancelamento of cancelamentos">
                            <div>
                                - {{ cancelamento.motivo }}
                            </div>
                            <div class="lh-sm fs-7 text-gray" style="margin-bottom: 10px;">
                                ({{ cancelamento.created_at | date:'dd/MM/yyyy HH:mm:ss' }})
                            </div>                            
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-2" *ngIf="dio.alocacao">
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">
                            <span class="fw-bold fs-7 opacity-50">HODÔMETRO INICIAL </span>
                            <div class="lh-sm">{{ dio.hodometroInicial ? dio.hodometroInicial + ' km' : '---' }}</div>
                        </div>
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'MAQUINAS'">
                            <span class="fw-bold fs-7 opacity-50">HORÍMETRO INICIAL</span>
                            <div class="lh-sm">{{ dio.horimetroInicial ? dio.horimetroInicial + ' horas' : '---' }}</div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-2" *ngIf="dio.alocacao">
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">
                            <span class="fw-bold fs-7 opacity-50">HODÔMETRO FINAL</span>
                            <div class="lh-sm">{{ dio.hodometroFinal ? dio.hodometroFinal + ' km' : '---' }}</div>
                        </div>
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'MAQUINAS'">
                            <span class="fw-bold fs-7 opacity-50">HORÍMETRO FINAL</span>
                            <div class="lh-sm">{{ dio.horimetroFinal ? dio.horimetroFinal + ' horas' : '---' }}</div>                        
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">STATUS CONCLUSÃO</span>
                        <div class="d-flex" *ngIf="dio.statusConclusao">
                            <span class="status-badge {{getBadgeColor(dio.statusConclusao)}}">{{ dio.statusConclusao | translate }}</span>
                        </div>
                        <div *ngIf="!dio.statusConclusao">---</div>
                    </div>
                    <div class="col-12 col-md-4 mb-2" *ngIf="dio.alocacao">
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">
                            <span class="fw-bold fs-7 opacity-50">TOTAL ODÔMETRO CONDUTOR</span>
                            <div class="lh-sm">{{ dio.hodometroInicial && dio.hodometroFinal ? (dio.hodometroFinal - dio.hodometroInicial) + ' km' : '---' }}</div>
                        </div>                        
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'MAQUINAS'">
                            <span class="fw-bold fs-7 opacity-50">TOTAL HORÍMETRO</span>
                            <div class="lh-sm">{{ dio.horimetroInicial && dio.horimetroFinal ? (dio.horimetroFinal - dio.horimetroInicial) + ' horas' : '---' }}</div>                        
                        </div>
                    </div>                            
                    <div class="col-12 col-md-4 mb-3">
                        <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">
                            <span class="fw-bold fs-7 opacity-50">TOTAL ODÔMETRO GPS</span>
                            <div class="lh-sm">{{ execucaoGPS && execucaoGPS.kmRodados ? execucaoGPS.kmRodados + ' km' : '---' }}</div>
                        </div>
                    </div>        
                    <div class="col-12 mb-2">
                        <mat-divider></mat-divider>
                    </div>                    
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">INICIO DA OPERAÇÃO</span>
                        <div class="lh-sm">{{ dio.dataPeriodoInicioOperacao ? (dio.dataPeriodoInicioOperacao | date:'dd/MM/yyyy') : '---' }}
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">FIM DA OPERAÇÃO</span>
                        <div class="lh-sm">{{ dio.dataPeriodoFimOperacao ? (dio.dataPeriodoFimOperacao | date:'dd/MM/yyyy') : '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                        <span class="fw-bold fs-7 opacity-50">MOTIVO DESVIO</span>
                        <div class="lh-sm">{{ dio.motivoDesvio || '---' }}</div>
                    </div>
                    <div class="col-12 col-md-4 mb-2">
                        <span class="fw-bold fs-7 opacity-50">DETALHES DE EXECUÇÃO</span>
                        <div class="lh-sm" *ngIf="dio.execucaoDetalhesValida && dio.execucaoDetalhesValida.imagens && dio.execucaoDetalhesValida.imagens.length">
                            <button mat-button color="primary" (click)="openCarousel(dio.execucaoDetalhesValida.imagens)">
                                <mat-icon>collections</mat-icon> {{ dio.execucaoDetalhesValida.imagens.length }} imagen(s)
                            </button>
                        </div>
                        <div class="lh-sm" *ngIf="!dio.execucaoDetalhesValida || !dio.execucaoDetalhesValida.imagens || !dio.execucaoDetalhesValida.imagens.length">{{ '---' }}</div>
                    </div>

                    <!-- tarifação -->
                    <ng-container *ngIf="canReadTarifacoes()">
                        <div class="col-12 mb-3">
                            <mat-divider></mat-divider>
                        </div>
                        <h2 class="fs-6 mb-1">TARIFAÇÃO</h2>
                        <div class="col-12 col-md-4 mb-3" *ngIf="dio.alocacao.grupoTarifacaoTipo === 'MAQUINAS'">
                            <span class="fw-bold fs-7 opacity-50">VALOR/HORA DISPONÍVEL MÁQUINA</span>
                            <div class="lh-sm">{{ dio.alocacao.valorHoraDisponivelMaquina | currency: 'BRL' }}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3" *ngIf="dio.alocacao.grupoTarifacaoTipo === 'MAQUINAS'">
                            <span class="fw-bold fs-7 opacity-50">VALOR/HORA FUNCIONAMENTO MÁQUINA</span>
                            <div class="lh-sm">{{ dio.alocacao.valorHoraProduzida | currency: 'BRL' }}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3" *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">
                            <span class="fw-bold fs-7 opacity-50">VALOR/HORA DISPONÍVEL VEÍCULO</span>
                            <div class="lh-sm">{{ dio.alocacao.valorHoraDisponivelVeiculo | currency: 'BRL' }}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3" *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">
                            <span class="fw-bold fs-7 opacity-50">VALOR/HORA KM RODADO</span>
                            <div class="lh-sm">{{ dio.alocacao.valorKmRodado | currency: 'BRL' }}</div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="podeExibirUsoEquipamento()">
                        <div class="col-12 mb-3">
                            <mat-divider></mat-divider>
                        </div>
                        <h2 class="fs-6 mb-1">USO DO EQUIPAMENTO</h2>
                        <div class="col-12 col-md-4 mb-3">
                            <span class="fw-bold fs-7 opacity-50">TIPO DO EQUIPAMENTO</span>
                            <div class="lh-sm">{{ dio.alocacao.grupoTarifacaoTipo }}</div>
                            <div class="lh-sm fs-7 text-gray">{{ dio.execucaoDetalhesValida!.tipo || '' }}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <span class="fw-bold fs-7 opacity-50">TEMPO DE DISPONIBILIDADE</span>
                            <div class="lh-sm">{{ formatHumanTime(dio.execucaoDetalhesValida!.disponibilidadeTotalMinutes) }}</div>
                            <div class="lh-sm fs-7 text-gray">{{ dio.execucaoDetalhesValida!.tipo || '' }}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'MAQUINAS'">
                                <span class="fw-bold fs-7 opacity-50">TEMPO DE FUNCIONAMENTO</span>
                                <div class="lh-sm">{{ formatHumanTime(dio.execucaoDetalhesValida!.funcionamentoTotalMinutes) }}</div>
                                <div class="lh-sm fs-7 text-gray">{{ dio.execucaoDetalhesValida!.tipo || '' }}</div>
                            </div>
                            <div *ngIf="dio.alocacao.grupoTarifacaoTipo === 'VEICULOS'">  
                                <span class="fw-bold fs-7 opacity-50">KM RODADOS</span>
                                <div class="lh-sm">{{ dio.execucaoDetalhesValida!.kmRodados + ' km' }}</div>
                                <div class="lh-sm fs-7 text-gray">{{ dio.execucaoDetalhesValida!.tipo || ''}}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                        </div>
                    </ng-container>
                    <ng-container *ngIf="canReadPrecificacoes()">
                        <div class="col-12 mb-3">
                            <mat-divider></mat-divider>
                        </div>
                        <ng-container *ngFor="let precificacao of precificacoes">
                            <h2 class="fs-6 mb-1">PRECIFICAÇÃO - {{ precificacao.tipoPrecificacao | translate }}</h2>
                            <div class="col-12 col-md-4 mb-3" *ngIf="precificacao.valorTotalDisponibilidadeMaquina">
                                <span class="fw-bold fs-7 opacity-50">TOTAL POR DISPONIBILIDADE MÁQUINA</span>
                                <div class="lh-sm">{{ precificacao.valorTotalDisponibilidadeMaquina | currency: 'BRL' }}</div>
                            </div>
                            <div class="col-12 col-md-4 mb-3" *ngIf="precificacao.valorTotalDisponibilidadeVeiculo">
                                <span class="fw-bold fs-7 opacity-50">TOTAL POR DISPONIBILIDADE VEÍCULO</span>
                                <div class="lh-sm">{{ precificacao.valorTotalDisponibilidadeVeiculo | currency: 'BRL' }}</div>
                            </div>
                            <div class="col-12 col-md-4 mb-3" *ngIf="isMaquina()">
                                <span class="fw-bold fs-7 opacity-50">TOTAL POR FUNCIONAMENTO</span>
                                <div class="lh-sm">{{ precificacao.valorTotalProduzido | currency: 'BRL' }}</div>
                            </div>
                            <div class="col-12 col-md-4 mb-3" *ngIf="isVeiculo()">
                                <span class="fw-bold fs-7 opacity-50">TOTAL POR KM RODADOS</span>
                                <div class="lh-sm">{{ precificacao.valorTotalKmRodado | currency: 'BRL' }}</div>
                            </div>
                            <div class="col-12 col-md-4 mb-3">
                                <span class="fw-bold fs-7 opacity-50">TOTAL</span>
                                <div class="lh-sm fw-bold text-danger">{{
                                    (precificacao.valorTotalDisponibilidadeMaquina +
                                    precificacao.valorTotalDisponibilidadeVeiculo +
                                    precificacao.valorTotalProduzido +
                                    precificacao.valorTotalKmRodado) | currency: 'BRL' }}</div>
                            </div>
                            <div class="col-12 col-md-4 mb-3" *ngIf="precificacao.valorTotalKmRodado">
                              <span class="fw-bold fs-7 opacity-50">TIPO</span>
                              <div class="lh-sm">{{ precificacao.precificacaoManual ? 'MANUAL' : 'AUTOMÁTICA' }}</div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- assinaturas -->
                    <div class="col-12 mb-3">
                        <mat-divider></mat-divider>
                    </div>
                    <h2 class="fs-6">ASSINATURAS</h2>
                    <ul class="timeline-ul">
                        <ng-container *ngFor="let item of [].constructor(3); index as index; first as first; last as last">
                            <li [ngClass]="{'only': first && last}">
                                <div class="timeline-div fst-italic text-gray text-center" *ngIf="index == 0 && !dio.assinaturas[index]">Aguardando conclusão do condutor</div>
                                <div class="timeline-div fst-italic text-gray text-center" *ngIf="index == 1 && !dio.assinaturas[index]">Aguardando atesto do funcionário</div>
                                <div class="timeline-div fst-italic text-gray text-center" *ngIf="index == 2 && !dio.assinaturas[index]">Aguardando validação do fiscal</div>
                                <ng-container *ngIf="dio.assinaturas[index]">
                                    <span>{{ dio.assinaturas[index].role | translate | uppercase }}</span>
                                    <div class="timeline-div text-center">
                                        <a href="javascript:;" class="d-block text-pink mb-2" *ngIf="dio.assinaturas[index].url"
                                            (click)="openSignatureDialog(dio.assinaturas[index])">
                                            {{ abreviateName(dio.assinaturas[index].userName) | titlecase }}
                                        </a>
                                        <div class="mb-2" *ngIf="!dio.assinaturas[index].url">
                                            {{ abreviateName(dio.assinaturas[index].userName) | titlecase }}
                                        </div>
                                        <div class="fs-7 opacity-50" *ngIf="!dio.assinaturas[index].observacao">Nenhuma observação</div>
                                        <div class="fs-7 opacity-50" *ngIf="dio.assinaturas[index].observacao">"{{ dio.assinaturas[index].observacao }}"</div>
                                        <div class="fs-7 opacity-50 pt-2 mt-3 border-top">
                                            {{ dio.assinaturas[index].created_at ? (dio.assinaturas[index].created_at | date:'dd/MM/yyyy HH:mm:ss') : '---' }}
                                        </div>
                                    </div>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <!-- MAPA -->
            <div class="callout border-warning pt-2 mb-4" 
                *ngIf="allowedViewMapaDio()">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <span class="fw-bold fs-7 opacity-50">MAPA</span>                        
                    </div>
                    <ng-container>
                        <div class="col-12 mb-2">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="col-12 col-md-4">
                          <div class="d-flex">
                            <button mat-flat-button class="bg-info" [routerLink]="['/dio', this.idDio, 'mapa']">
                                VER MAPA
                            </button>                            
                          </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- IMAGENS -->
            <div class="callout border-info pt-2 mb-4" *ngIf="imagens && imagens.length > 0">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <span class="fw-bold fs-7 opacity-50">IMAGENS</span>
                    </div>
                    <ng-container>
                        <div class="col-12 mb-2">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <!-- Preview das primeiras 3 imagens -->
                                <div class="col-12 col-md-4 mb-3" *ngFor="let imagem of imagens.slice(0, 3); let i = index">
                                    <div class="position-relative">
                                        <img [src]="imagem.url" [alt]="imagem.descricao || imagem.alt" 
                                             class="img-fluid cursor-pointer shadow-sm" 
                                             (click)="openImageCarousel(imagens)"
                                             style="border-radius: 8px; max-height: 200px; object-fit: cover; width: 100%; cursor: pointer; transition: transform 0.2s;" 
                                             onmouseover="this.style.transform='scale(1.05)'" 
                                             onmouseout="this.style.transform='scale(1)'" />
                                        <!-- Overlay para mostrar total de imagens na última -->
                                        <div *ngIf="i === 2 && imagens.length > 3" 
                                             class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                             style="background: rgba(0,0,0,0.6); border-radius: 8px; cursor: pointer;"
                                             (click)="openImageCarousel(imagens)">
                                            <span class="text-white fs-4 fw-bold">+{{ imagens.length - 3 }}</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- Botão para ver todas as imagens -->
                                <div class="col-12 mt-3">
                                    <button mat-button color="primary" (click)="openImageCarousel(imagens)">
                                        <mat-icon>collections</mat-icon> 
                                        Ver {{ imagens.length }} image{{ imagens.length > 1 ? 'ns' : 'm' }} em carrossel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- APONTAMENTOS -->
            <div class="callout border-success pt-2 mb-4" *ngIf="podeVerApontamentos()">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <h2 class="fs-6">APONTAMENTOS</h2>                        
                    </div>
                    <ng-container>
                        <div class="col-12 mb-2">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="col-12">
                            <table mat-table [dataSource]="apontamentos" class="mat-elevation-z8 w-100" *ngIf="apontamentos && apontamentos.length > 0">
                                <!-- Coluna Início -->
                                <ng-container matColumnDef="dataInicio">
                                    <th mat-header-cell *matHeaderCellDef> INÍCIO </th>
                                    <td mat-cell *matCellDef="let apontamento"> {{ apontamento.dataInicio | date:'dd/MM/yyyy HH:mm' }} </td>
                                </ng-container>
                        
                                <!-- Coluna Fim -->
                                <ng-container matColumnDef="dataFim">
                                    <th mat-header-cell *matHeaderCellDef> FIM </th>
                                    <td mat-cell *matCellDef="let apontamento"> {{ apontamento.dataFim | date:'dd/MM/yyyy HH:mm' }} </td>
                                </ng-container>
                        
                                <!-- KM -->
                                <ng-container matColumnDef="kmOrHoraTrabalhada">
                                    <div *ngIf="isVeiculo()">
                                        <th mat-header-cell *matHeaderCellDef> KM </th>
                                        <td mat-cell *matCellDef="let apontamento"> {{ apontamento.totalKmRodadosCancelados }} </td>
                                    </div>
                                    <div *ngIf="isMaquina()">
                                        <th mat-header-cell *matHeaderCellDef> HORAS TRABALHADAS </th>
                                        <td mat-cell *matCellDef="let apontamento"> {{ apontamento.totalHorasTrabalhadasCanceladas }} </td>
                                    </div>
                                </ng-container>                                

                                <!-- Horas Disponiveis -->
                                <ng-container matColumnDef="horasDisponiveis">
                                    <th mat-header-cell *matHeaderCellDef> Horas Disponíveis </th>
                                    <td mat-cell *matCellDef="let apontamento"> {{ apontamento.totalHorasDisponiveisCanceladas }} </td>
                                </ng-container>

                                <!-- Coluna Motivo -->
                                <ng-container matColumnDef="motivo">
                                    <th mat-header-cell *matHeaderCellDef> MOTIVO </th>
                                    <td mat-cell *matCellDef="let apontamento"> {{ apontamento.motivo }} </td>
                                </ng-container>                    

                                <!-- Coluna Responsável -->
                                <ng-container matColumnDef="usuarioResponsavelEmail">
                                    <th mat-header-cell *matHeaderCellDef> RESPONSÁVEL </th>
                                    <td mat-cell *matCellDef="let apontamento"> {{ apontamento.usuarioResponsavelNome }}
                                    <div class="fs-7 opacity-50" *ngIf="apontamento.usuarioResponsavelAferidorNumero">Aferidor: {{ apontamento.usuarioResponsavelAferidorNumero }}</div>
                                </ng-container>
                        
                                <!-- Cabeçalho da Tabela -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <!-- Linhas da Tabela -->
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <div class="text-center" *ngIf="apontamentos && apontamentos.length === 0">                                
                                <p class="text-gray">Nenhum apontamento encontrado</p>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- OBSERVAÇÕES -->
            <div class="callout border-success pt-2 mb-4" *ngIf="podeVerObservacoes()">
                <div class="row">
                    <div class="col-12 col-md-4">
                        <h2 class="fs-6">OBSERVAÇÕES</h2>                        
                    </div>
                    <ng-container>
                        <div class="col-12 mb-2">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="col-12">
                            <table mat-table [dataSource]="observacoes" class="mat-elevation-z8 w-100" *ngIf="observacoes && observacoes.length > 0">
                                <!-- Coluna Início -->
                                <ng-container matColumnDef="dataObservacao">
                                    <th mat-header-cell *matHeaderCellDef> DATA </th>
                                    <td mat-cell *matCellDef="let observacao"> {{ observacao.created_at | date:'dd/MM/yyyy HH:mm' }} </td>
                                </ng-container>                

                                <!-- Coluna Observação -->
                                <ng-container matColumnDef="textoObservacao">
                                    <th mat-header-cell *matHeaderCellDef> OBSERVAÇÃO </th>
                                    <td mat-cell *matCellDef="let observacao"> {{ observacao.textoObservacao }} </td>
                                </ng-container>                    

                                <!-- Coluna Responsável -->
                                <ng-container matColumnDef="responsavelObservacao">
                                    <th mat-header-cell *matHeaderCellDef> RESPONSÁVEL </th>
                                    <td mat-cell *matCellDef="let observacao"> {{ observacao.responsavel }}                                    
                                </ng-container>
                        
                                <!-- Cabeçalho da Tabela -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumnsObservacoes"></tr>
                                <!-- Linhas da Tabela -->
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsObservacoes;"></tr>
                            </table>
                            <div class="text-center" *ngIf="observacoes && observacoes.length === 0">                                
                                <p class="text-gray">Nenhuma observação encontrada</p>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <button mat-flat-button color="primary" (click)="openNovaObservacaoDialog()">
                                <mat-icon>add</mat-icon> Nova Observação
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- HISTÓRICO DE EVENTOS -->
            <div class="callout border-primary pt-2 mb-4" *ngIf="eventos && eventos.length > 0">
                <div class="row">
                    <div class="col-12">
                        <h2 class="fs-6">HISTÓRICO DE EVENTOS</h2>
                    </div>
                    <div class="col-12 mb-3">
                        <mat-divider></mat-divider>
                    </div>
                    <div class="col-12">
                        <ul class="timeline-ul">
                            <li *ngFor="let evento of eventos; let i = index; let first = first; let last = last" 
                                [ngClass]="{'only': first && last}">
                                <span class="fw-bold">{{ evento.tipoEvento | translate }}</span>
                                <div class="timeline-div">
                                    <div class="mb-2">
                                        <mat-icon class="align-middle me-1" style="font-size: 18px;">event</mat-icon>
                                        <span class="fs-7">{{ evento.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                                    </div>
                                    
                                    <div class="mb-1" *ngIf="evento.statusExecucaoAtual">
                                        <span class="fw-bold fs-7 opacity-50">STATUS EXECUÇÃO:</span>
                                        <div class="d-flex mt-1">
                                            <span class="status-badge {{getBadgeColor(evento.statusExecucaoAtual)}} fs-7">
                                                {{ evento.statusExecucaoAtual | translate }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="mb-1" *ngIf="evento.statusConclusaoAtual">
                                        <span class="fw-bold fs-7 opacity-50">STATUS CONCLUSÃO:</span>
                                        <div class="d-flex mt-1">
                                            <span class="status-badge {{getBadgeColor(evento.statusConclusaoAtual)}} fs-7">
                                                {{ evento.statusConclusaoAtual | translate }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="mb-1" *ngIf="evento.statusAfericaoAtual">
                                        <span class="fw-bold fs-7 opacity-50">STATUS AFERIÇÃO:</span>
                                        <div class="d-flex mt-1">
                                            <span class="status-badge {{getBadgeColor(evento.statusAfericaoAtual)}} fs-7">
                                                {{ evento.statusAfericaoAtual | translate }}
                                            </span>
                                        </div>
                                    </div>

                                    <div class="mt-2" *ngIf="evento.usuarioNome">
                                        <mat-icon class="align-middle me-1" style="font-size: 16px;">person</mat-icon>
                                        <span class="fs-7 text-gray">{{ evento.usuarioNome }}</span>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- AFERIÇÃO -->
            <div class="callout border-warning pt-2" *ngIf="allowedAferirDio() && dio.statusAfericao">
                <div class="row">
                    <div class="col-12 col-md-4 mb-3">
                        <span class="fw-bold fs-7 opacity-50">STATUS AFERIÇÃO</span>
                        <div class="d-flex">
                            <span class="status-badge {{getBadgeColor(dio.statusAfericao)}}">{{ dio.statusAfericao | translate }}</span>
                        </div>
                    </div>
                    <ng-container  *ngIf="dio.afericao && dio.afericao.aferidor">
                        <div class="col-12 col-md-4 mb-3">
                            <span class="fw-bold fs-7 opacity-50" >AFERIDOR</span>
                            <div class="lh-sm">{{ dio.afericao.aferidor.firstName ? dio.afericao.aferidor.firstName + ' ' + dio.afericao.aferidor.lastName : '---' }}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3">
                            <span class="fw-bold fs-7 opacity-50">DATA DISPONIBILIZACAO</span>
                            <div class="lh-sm">{{ dio.afericao.dataDisponibilizacao ? (dio.afericao.dataDisponibilizacao | date:'short') :  '---'}}</div>
                        </div>
                        <div class="col-12 col-md-4 mb-3" *ngIf="dio.afericao.dataFinalizacao">
                            <span class="fw-bold fs-7 opacity-50">DATA DE AFERIÇÃO</span>
                            <div class="lh-sm">{{ dio.afericao.dataFinalizacao ? (dio.afericao.dataFinalizacao | date:'short') :  '---'}}</div>
                        </div>
                    </ng-container>                    
                    <ng-container *ngIf="dio.statusAfericao == 'AGUARDANDO_AFERICAO' && dio.afericao.status != 'PENDENTE_APROVACAO'">
                        <div class="col-12 my-2">
                            <mat-divider></mat-divider>
                        </div>
                        <div class="col-12 col-md-4">
                          <div class="d-flex">
                            <button mat-flat-button color="warn" (click)="iniciarAfericao()">
                                AFERIR DIO
                            </button>
                            <button mat-flat-button class="ms-3 text-bg-secondary" (click)="openUpdateAferidorDialog()" *ngIf="canChangeAferidor()">
                                MUDAR AFERIDOR
                            </button>
                          </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="podeVerAfericao()">
                      <div class="col-12 my-2">
                          <mat-divider></mat-divider>
                      </div>
                      <div class="col-12 col-md-4">
                        <div class="d-flex">
                          <button mat-flat-button color="warn" [appOpenInNewTab]="['/dio', this.idDio, 'aferir']">
                              VER AFERIÇÃO
                          </button>
                        </div>
                      </div>
                  </ng-container>
                </div>
            </div>
        </ng-container>
    </mat-card>
</div>

<print-dio
    [dio]="dio"
    [apontamentos]="apontamentos"
    [observacoes]="observacoes"
    [eventos]="eventos"
    [precificacoes]="precificacoes"
    [imagens]="imagens"
    [cancelamentos]="cancelamentos"
    [execucaoGPS]="execucaoGPS"
    [showTarifacoes]="canReadTarifacoes()"
    [showUsoEquipamento]="podeExibirUsoEquipamento()"
    [showPrecificacoes]="canReadPrecificacoes()"
    [showApontamentos]="podeVerApontamentos()"
    [showObservacoes]="podeVerObservacoes()"
    [showMapa]="allowedViewMapaDio()"
    [showAfericao]="allowedAferirDio()"
    [showVerAfericao]="podeVerAfericao()"
></print-dio>